import APITemplate from '@/api/APITemplate'

export default APITemplate('/api/io-parameter')
